import { defineComponent as _defineComponent } from 'vue'
import { AbTitle, AbLink, AbTag } from '../../../ui';
import { type TextAlign } from '../../../../types';
import { CdnImg } from '@webplatform/cdn-image';

interface Props {
  item: {
    image?: {
      src?: string | null;
      alt?: string | null;
    } | null;
    title: string;
    link?: string | null;
    tags?: string[] | null;
    contentAlign?: TextAlign | null;
    creative_name?: string | null;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogSectionSimpleItem',
  props: {
    item: null
  },
  emits: ["click"],
  setup(__props: any) {




return { __sfc: true,AbTitle, AbLink, AbTag, CdnImg }
}

})